import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";

export interface ProdutoSaldoRow {
  localEstoqueId: number;
  localDescricao?: string | null;
  saldoAtual: number;
  saldoReservado: number;
  saldoCondicional: number;
  saldoDisponivel: number;
}

export const useProdutoSaldo = (produtoId: string | undefined) => {
  const numId = produtoId ? Number(produtoId) : undefined;
  const query = useQuery({
    queryKey: ["produto-saldo", numId],
    queryFn: async () => (await apiClient.get<ProdutoSaldoRow[]>(`/api/produtos/${numId}/saldo`)).data,
    enabled: !!numId,
  });
  return { saldos: query.data ?? [], isLoading: query.isLoading };
};
